










































  import { Validable } from '@/commun/components/champ-formulaire/mixins/validable';
  import { clamp } from '@/commun/utils/numerique-utils';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'StepperNombre',
    mixins: [Validable],
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Number,
        default: null,
      },
      label: {
        type: String,
        default: '',
      },
      min: {
        type: Number,
        default: Number.MIN_SAFE_INTEGER,
      },
      max: {
        type: Number,
        default: Number.MAX_SAFE_INTEGER,
      },
      precision: {
        type: Number,
        default: 0,
      },
      afficherPlaceholder: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      iconeMoins: 'mdi-minus',
      iconePlus: 'mdi-plus',
      valeurInterne: '',
      valeurPrecedente: 0,
    }),
    computed: {
      placeholder(): string {
        const valeurPlaceholder = 0;
        return valeurPlaceholder.toFixed(this.precision);
      },
      peutDecrementer(): boolean {
        return this.value > this.min;
      },
      peutIncrementer(): boolean {
        return this.value < this.max;
      },
    },
    watch: {
      value(nouvelleValeur: number) {
        this.mettreAJourValeurInterne(nouvelleValeur);
      },
    },
    created() {
      this.mettreAJourValeurInterne(this.value);
    },
    methods: {
      decrementer(): void {
        this.mettreAJourValeur(this.value - 1);
      },
      incrementer(): void {
        if (this.value === null) {
          this.mettreAJourValeur(0);
        } else {
          this.mettreAJourValeur(this.value + 1);
        }
      },
      onValueChange(nouvelleValeur: string): void {
        if (nouvelleValeur === '') {
          this.mettreAJourValeurNulle();
          return;
        }
        this.mettreAJourValeur(+nouvelleValeur);
      },
      mettreAJourValeurNulle(): void {
        this.$emit('input', null);
        this.mettreAJourValeurInterne(null);
      },
      mettreAJourValeur(valeur: number): void {
        const valeurNumerique: number = clamp(valeur, this.min, this.max);
        this.$emit('input', valeurNumerique);
        this.mettreAJourValeurInterne(valeurNumerique);
      },
      mettreAJourValeurInterne(valeur: number | null): void {
        if (valeur === null) {
          this.valeurInterne = '';
          return;
        }
        this.valeurInterne = valeur.toFixed(this.precision);
      },
    },
  });
